export default [
  {
    path: 'afiliados/reference-comission-plans',
    name: 'reference-comission-plans',
    component: () => import('./index'),
    meta: {
      visible: true,
      title: 'Planos de Comissão de Referência',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados', link: 'afiliados' },
        { name: 'Plano de Comissão de Referência' }
      ]
    }
  }
]